module.exports = __webpack_public_path__ + "img/diangu@2x.dfd1cbe3.png";